import isEmpty from 'lodash/isEmpty';

export const shouldShowStoreError = (res: string) => {
  if (isEmpty(res)) return true;
  return !res.toLowerCase().includes('successfully');
};
